export const environment = {
  production: true,
  configUrl: "https://api.maxor.com/ConfigApi/v1.0/Configuration/GetConfigurationSettings",
  castConfig: true
};
